import { PROFILE_TAB_MIGRATION_VERSION } from './profileTabMigration';

/**
 * Tour Planner saves tour folders with venue `savedVenue` file rows. After profile tab migration,
 * those folders must sit under `profileTabRoots.toursFolderId` (My Tours), not `parentId: null`.
 *
 * @param {object} userData - `users/{uid}` document data
 * @param {object} [existingFolder] - `folders[folderId]` before this save (may be `{}`)
 * @returns {string|null} `parentId` to persist — `null` means legacy top-level library root (pre-migration)
 */
export function getParentIdForSavedTourFolder(userData, existingFolder = {}) {
  const roots = userData?.profileTabRoots;
  const toursRootId = roots?.toursFolderId;
  if (!toursRootId) return null;
  if (typeof roots.migrationVersion !== 'number' || roots.migrationVersion < PROFILE_TAB_MIGRATION_VERSION) {
    return null;
  }
  if (existingFolder.tour) {
    if (existingFolder.parentId != null && existingFolder.parentId !== undefined) {
      return existingFolder.parentId;
    }
    return toursRootId;
  }
  return toursRootId;
}
